import type { BaseModel } from './baseModel';

interface CrmUploadHistoryEntry {
  requestPayload: unknown;
  response: unknown;
  datetime: string;
}

export interface Lead extends BaseModel {
  clientId: number;
  source: string;
  initialBrandOfInterest: string | null;
  initialModelOfInterest: string | null;
  initialMessage: string | null;
  webhookBodyAtCreation: string | null;
  outboundCampaignId: string | null;
  CRMUpdateAt: Date | null;
  CRMCreationPayload: object | null;
  CRMCreationResponse: object | null;
  messagesCount: number;
  clientMessagesCount: number;
  discarded: boolean;
  status: string;
  url: string | null;
  UTM?: {
    source: string;
    medium: string;
    campaign: string;
    content: string;
    term: string;
  };
  visitDate?: Date | null;
  endReason?: string | null;
  AIComment?: string | null;
  crmUploadHistory: CrmUploadHistoryEntry[] | null;
  sourceId?: string | null;
  sourceType?: string | null;
}

export interface ExtendedLead extends Lead {
  client?: {
    id: number;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    messagesCount: number;
    clientMessagesCount: number;
    failedMessagesCount: number;
    userId: number;
    user?: {
      id: number;
      name: string;
    };
    businessUnit: {
      id: number;
      name: string;
    };
  };
}

export const ALLOWED_CLOSE_LEAD_STATUSES = ['Éxito', 'Fracaso'] as const;
export type CloseLeadStatus = (typeof ALLOWED_CLOSE_LEAD_STATUSES)[number];
